// extracted by mini-css-extract-plugin
export default {"container":"sub_2gEpY","card":"sub_car_2pgkw","inner":"sub_inn_1VCBn"};